// LandingWrapper.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import Landing from "../src/components/layouts/Landing";

const LandingWrapper = ({ setShowModal }) => {
  const navigate = useNavigate();
  return <Landing navigate={navigate} setShowModal={setShowModal} />;
};

export default LandingWrapper;
